import React, { PropsWithChildren } from "react";
import NavigationBar from "./NavigationBar";
import { WithGrow } from "@common/components/WithGrow";
import { BreadcrumbProps as BreacrumbsPropsType } from "../common/Breadcrumb/types";

type RoomsRealtimeProps = {
  BreadcrumbProps?: BreacrumbsPropsType;
};

const RoomsRealtime = ({
  BreadcrumbProps = {},
  children,
}: PropsWithChildren<RoomsRealtimeProps>) => {
  return (
    <WithGrow
      direction="column"
      fixed={<NavigationBar BreadcrumbProps={BreadcrumbProps} />}
    >
      {children}
    </WithGrow>
  );
};

export default RoomsRealtime;
